export {
    TextBaseInput,
    TextBaseInputWithIcons,
    type TextBaseInputProps,
    type TextBaseInputWithIconsProps
} from './TextBaseInput';
export { sharedInputVariants, sharedInputWithIconVariants, default as TextInput } from './TextInput';
export { type TextInputProps } from './TextInput';
